var Base = require('front/components/Base/Base');
var ArticlesList = require('front/components/ArticlesList/ArticlesList');
var ArchiveFilters = require('front/components/ArchiveFilters/ArchiveFilters');

require('./Broadcasts.less');

module.exports = Base.extend({
    el: '.Broadcasts',

    initialize: function () {
        this.articlesList = new ArticlesList({
            limit: 12,
            dataOptions: {
                is_broadcast: 'True'
            }
        });

        new ArchiveFilters(window.app.data.archiveOptions);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/Broadcasts/Broadcasts.js
// module id = 184
// module chunks = 0